export const GET_PARENT_GROUP_SUCCESS = "GET_PARENT_GROUP_SUCCESS";
export const TOGGLE_PARENT_GROUP_SUCCESS = "TOGGLE_PARENT_GROUP_SUCCESS";
